import { useEffect } from "react";

import logo from "../../assets/echovibe.png";
import aibg from "../../assets/aibg.png";
import { Link } from "react-router-dom";
import { APP_ROUTES } from "../../constants/appRoutes";
import { PRIVACY_URL, TERMS_URL } from "../../constants/legalUrls";
import { LegalLink } from "./LegalFooterLinks";
import "bootstrap-icons/font/bootstrap-icons.css";

const legalLinkClassName = "text-xs text-blue-900 hover:text-blue-950";
const legalLinkDisabledClassName = "text-xs text-slate-400 cursor-not-allowed";

export default function FullWidthLayout({ children }) {
    useEffect(() => {
        const prevBodyOverflow = document.body.style.overflow;
        const prevHtmlOverflow = document.documentElement.style.overflow;

        document.body.style.overflow = "auto";
        document.documentElement.style.overflow = "auto";

        return () => {
            document.body.style.overflow = prevBodyOverflow;
            document.documentElement.style.overflow = prevHtmlOverflow;
        };
    }, []);

    return (
        <div className="relative min-h-screen bg-slate-50 px-2 sm:px-4 md:px-24">
            <div
                className="pointer-events-none fixed inset-0 bg-cover bg-center bg-no-repeat opacity-40"
                style={{ backgroundImage: `url(${aibg})` }}
                aria-hidden
            />
            <header className="relative z-10 flex justify-center pt-8 md:pt-12">
                <Link to={APP_ROUTES.LANDING} title="Home">
                    <img src={logo} alt="EzePulse" className="h-10 w-auto md:h-11" />
                </Link>
            </header>
            <main className="relative z-10 pb-10 pt-6 md:pb-16 md:pt-8 max-w-7xl mx-auto">
                {children}
            </main>
            <footer className="relative z-10 py-4">
                <div className="flex flex-col gap-3 md:hidden">
                    <p className="text-center text-xs text-slate-900">
                        © {new Date().getFullYear()} EzePulse. All rights reserved.
                    </p>
                    <div className="grid grid-cols-2">
                        <LegalLink
                            href={TERMS_URL}
                            enabledClassName={`text-center ${legalLinkClassName}`}
                            disabledClassName={`text-center ${legalLinkDisabledClassName}`}
                        >
                            Terms &amp; Conditions
                        </LegalLink>
                        <LegalLink
                            href={PRIVACY_URL}
                            enabledClassName={`text-center ${legalLinkClassName}`}
                            disabledClassName={`text-center ${legalLinkDisabledClassName}`}
                        >
                            Privacy Policy
                        </LegalLink>
                    </div>
                </div>
                <div className="hidden items-center justify-between md:flex">
                    <p className="text-xs text-slate-900">
                        © {new Date().getFullYear()} EzePulse. All rights reserved.
                    </p>
                    <div className="flex items-center gap-2">
                        <LegalLink
                            href={TERMS_URL}
                            enabledClassName={legalLinkClassName}
                            disabledClassName={legalLinkDisabledClassName}
                        >
                            Terms &amp; Conditions
                        </LegalLink>
                        <i className="bi bi-dot" aria-hidden />
                        <LegalLink
                            href={PRIVACY_URL}
                            enabledClassName={legalLinkClassName}
                            disabledClassName={legalLinkDisabledClassName}
                        >
                            Privacy Policy
                        </LegalLink>
                    </div>
                </div>
            </footer>
        </div>
    );
}
